import React from 'react';
import InviteMember from "./InviteMember";
import Translate from "../../../../../components/Translate";
import CustomInput from "../../../../../components/input-text";
import BlueButton from "../../../../../components-new/buttons/BlueButton";
import TranslateProperty from "../../../../../components/TranslateProperty";
import CustomSelect from 'components/select';
import FileUpload from "../../../../../components/FileUpload";
import CheckboxWithTooltip from "../../../../../components-new/CheckboxWithTooltip";
import {titleStyles} from "../../../../../utils/General";

const InviteEmployees = ({
                             user,
                             company,
                             addNotification,
                             commonStyles,
                             fetchCompany,
                             email,
                             username,
                             firstName,
                             lastName,
                             password,
                             thumbUrl,
                             role,
                             language,
                             roles,
                             locales,
                             canChangeHimselfInfo,
                             handleChange,
                             handleAddUser,
                             handleHimselfInfoCheckboxChange,
                         }) => {
    return (
        <React.Fragment>
            <div style={{padding: '32px', width: '100%'}} className="bg-white">
                <InviteMember
                    user={user}
                    company={company}
                    addNotification={addNotification}
                    commonStyles={commonStyles}
                    fetchCompany={fetchCompany}
                />
            </div>

            <br/>

            <div style={{padding: '32px', width: '100%'}} className="bg-white">
                <div style={{display: 'flex', flexDirection: 'column', gap: '24px'}}>
                    <div style={{display: 'flex', gap: '24px', flexWrap: 'wrap'}}>
                        <div style={{display: 'flex', gap: '16px'}}>
                            <div>
                                <FileUpload
                                    windowSize={120}
                                    editIconSize={36}
                                    progressSize={22}
                                    editIconPos={0}
                                    handleChange={handleChange('thumbUrl')}
                                    image={thumbUrl}
                                />
                            </div>

                            <div style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
                                <TranslateProperty properties={[{key: 'placeholder', value: 'email'}]}>
                                    <CustomInput
                                        controlled
                                        handleChange={handleChange('email')}
                                        value={email}
                                        inputStyles={{width: '100%', height: '50px'}}
                                    />
                                </TranslateProperty>

                                <TranslateProperty properties={[{key: 'placeholder', value: 'username'}]}>
                                    <CustomInput
                                        controlled
                                        handleChange={handleChange('username')}
                                        value={username}
                                        inputStyles={{width: '100%', height: '50px'}}
                                    />
                                </TranslateProperty>
                            </div>
                        </div>

                        <div style={{display: 'flex', flexDirection: 'column', gap: '12px', flex: 1}}>
                            <TranslateProperty properties={[{key: 'placeholder', value: 'firstName'}]}>
                                <CustomInput
                                    controlled
                                    handleChange={handleChange('firstName')}
                                    value={firstName}
                                    inputStyles={{width: '100%', height: '50px'}}
                                />
                            </TranslateProperty>

                            <TranslateProperty properties={[{key: 'placeholder', value: 'lastName'}]}>
                                <CustomInput
                                    controlled
                                    handleChange={handleChange('lastName')}
                                    value={lastName}
                                    inputStyles={{width: '100%', height: '50px'}}
                                />
                            </TranslateProperty>

                            <TranslateProperty properties={[{key: 'placeholder', value: 'password'}]}>
                                <CustomInput
                                    controlled
                                    handleChange={handleChange('password')}
                                    value={password}
                                    inputStyles={{width: '100%', height: '50px'}}
                                />
                            </TranslateProperty>
                        </div>

                        <div style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
                            <CustomSelect
                                options={roles}
                                selected={role}
                                height={40}
                                title={role.title}
                                itemHoverColor="#F04D4D"
                                handleSelect={handleChange('role')}
                                wrapperStyles={{boxShadow: 'none', width: '120px'}}
                            />
                            <CustomSelect
                                options={locales}
                                selected={language}
                                height={40}
                                title={language.title}
                                itemHoverColor="#F04D4D"
                                handleSelect={handleChange('language')}
                                wrapperStyles={{boxShadow: 'none', width: '120px'}}
                            />
                            <div style={{marginLeft: '11px'}}>
                                <CheckboxWithTooltip
                                    tooltip="operatorCanChangeHimselfInfo"
                                    checked={canChangeHimselfInfo}
                                    type="checkbox"
                                    setChecked={handleHimselfInfoCheckboxChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div>
                        <BlueButton
                            type="button"
                            width="120px"
                            styles={{marginLeft: '0px'}}
                            onClick={handleAddUser}
                            children={<Translate text="add"/>}
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default InviteEmployees;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/InviteEmployees.jsx